/**
 * Fake responses to return when bot activity is detected
 * These responses mimic real API responses but contain fake data
 */

export const FAKE_AUTH_SUCCESS = {
  message: "Authentication successful",
  user: {
    id: "bot-detected-fake-id",
    email: "fake@example.com",
  },
};

export const FAKE_METRIC_SUGGESTIONS = [
  {
    key: "water_intake",
    name: "Water Intake",
    emoji: "💧",
    unit: "oz",
    description: "Track your daily water consumption",
  },
  {
    key: "steps",
    name: "Steps",
    emoji: "👟",
    unit: "steps",
    description: "Monitor your daily step count",
  },
  {
    key: "sleep_hours",
    name: "Sleep",
    emoji: "😴",
    unit: "hours",
    description: "Log your nightly sleep duration",
  },
];

export const FAKE_AI_METRICS_RESPONSE = {
  metrics: FAKE_METRIC_SUGGESTIONS,
  message: "Here are some suggested metrics based on your input",
};

/**
 * Returns a promise that resolves with fake data after a delay
 * to mimic an API call
 */
export const getFakeBotResponse = <T>(data: T, delayMs: number = 800): Promise<T> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("[BotDetection] Returning fake response to suspected bot");
      resolve(data);
    }, delayMs);
  });
};
